import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import LocaleInfo from "./locale-info";

const LocalesMenu = ({ availableLocales, locale, onLocaleChange }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLocaleChange = locale => {
    handleClose();
    onLocaleChange(locale);
  };

  return (
    <>
      <LocaleInfo locale={locale} onClick={handleClick} />
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {availableLocales.map(availableLocale => (
          <MenuItem key={availableLocale} onClick={() => handleLocaleChange(availableLocale)}>
            <FormattedMessage id={`common.locale.in.${availableLocale}`} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

LocalesMenu.propTypes = {
  /**
   * Lista de locales disponibles
   **/
  availableLocales: PropTypes.arrayOf(PropTypes.string).isRequired,
  /**
   * Locale configurado para el usuario
   **/
  locale: PropTypes.string.isRequired,
  /**
   * Handler que se llama al seleccionar un locale del menú de locales
   **/
  onLocaleChange: PropTypes.func.isRequired,
};

export default LocalesMenu;
